/**
 * Returns the total number of DOM elements inside the given element.
 *
 * Uses the native `getElementsByTagName('*')`, which counts descendants iteratively in the
 * browser engine -- intentionally not a recursive JS walk, so it can't overflow the stack on
 * very large documents.
 */
export function countDomElements(element: Element): number {
	return element.getElementsByTagName('*').length;
}
